import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ButtonDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import { STATE_PENDING, STATE_VERIFIED, STATE_DISABLED } from 'Constants/Business';
import { сhangeState } from 'store/slices/adminSlice';
import Loading from '../../Loading';

function BusinessState({
  business,
  сhangeState
}) {
  const {
    t
  } = useTranslation();
  const {
    objectId,
    id,
    state
  } = business;
  const targetId = objectId || id;

  const getColorClass = state => {
    switch (state) {
      case STATE_PENDING:
        return 'text-warning';

      case STATE_VERIFIED:
        return 'text-primary';

      case STATE_DISABLED:
        return 'text-danger';

      default:
        return 'text-body';
    }
  };

  const [isOpen, setOpen] = useState(false);

  const toggle = () => setOpen(!isOpen);

  const formatState = state => state.slice(0, 1).toUpperCase() + state.slice(1);

  const [loading, setLoading] = useState(false);

  const updateState = newState => {
    setLoading(true);
    сhangeState(targetId, newState).catch(err => console.log(err)).finally(() => {
      setLoading(false);
      setOpen(false);
    });
  };

  return <ButtonDropdown isOpen={isOpen} toggle={toggle}>
      <DropdownToggle caret color='link' className={`${getColorClass(state)} p-0`} onClick={e => {
      e.stopPropagation();
      toggle();
    }}>
        {formatState(state)}
      </DropdownToggle>

      <DropdownMenu>
        <DropdownItem header>{t("New state")}</DropdownItem>
        {[STATE_VERIFIED, STATE_PENDING, STATE_DISABLED].map(s => <DropdownItem key={`dropdown-${s}-${targetId}`} disabled={loading || s === state} toggle={false} onClick={e => {
        e.stopPropagation();
        updateState(s);
      }}>{formatState(s)}</DropdownItem>)}
        {loading && <Loading />}
      </DropdownMenu>
    </ButtonDropdown>;
}

const mapDispatchToProps = dispatch => ({
  сhangeState: (id, state) => dispatch(сhangeState(id, state))
});

export default connect(null, mapDispatchToProps)(BusinessState);